import { ReferenceLap } from '../models/responseBodies/ReferenceLapsResponse';
import { DriverLapHit } from '../models/responseBodies/DriverReferenceSearchResult';

/**
 * Build a ReferenceLap from a driver-search lap hit. The caller picks which
 * hit (best-ever or last-session) and supplies driverId + driverName from
 * the parent card. raceId, lap number, per-sector splits, and the orphan-lap
 * location are not surfaced by the search endpoint.
 *
 * The zero / empty defaults are intentional:
 *   - sec1/sec2/sec3 = 0 → StatStrip's sector cards already guard with `> 0`,
 *     so per-sector deltas silently hide (graceful — no broken "00:00.000" rows).
 *   - location = '' → falsy, so DriverClient.getLapTelemetry omits the optional
 *     `location` query param (the /telemetry/lap/{lapId} endpoint accepts the
 *     lap id alone).
 */
export function referenceLapFromSearch(
  driverId: string,
  driverName: string,
  hit: DriverLapHit
): ReferenceLap {
  return {
    id: hit.lapId,
    driverId,
    driverName,
    raceId: '',
    lap: 0,
    time: hit.lapTime,
    sec1: 0,
    sec2: 0,
    sec3: 0,
    date: hit.sessionDate,
    sessionDate: hit.sessionDate,
    location: '',
  };
}
